export default __webpack_public_path__ + "static/media/maurice-krubh.d2d1c34e.png";